
export const arrayPartialMatch = (arrayToCheck, elementsToCheck) => 
    elementsToCheck?.some(i => arrayToCheck?.includes?.(i));